import { flagshipTimeline, type TimelineNode } from "@/mocks/guaMore";

const typeStyle: Record<TimelineNode["type"], { label: string; dot: string; badge: string }> = {
  start: { label: "发酵", dot: "bg-stone-400", badge: "bg-stone-100 text-stone-600" },
  mid: { label: "发展", dot: "bg-amber-500", badge: "bg-amber-100 text-amber-900" },
  turn: { label: "反转", dot: "bg-red-600", badge: "bg-red-700 text-white" },
  result: { label: "最新", dot: "bg-emerald-600", badge: "bg-emerald-600 text-white" },
};

export default function Timeline() {
  const title = "「老杨逛吃」抄袭争议 · 完整时间线复盘";
  return (
    <section id="timeline" className="w-full bg-white">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-[0.2em] text-red-700">从发酵到出结果</p>
          <h2 className="font-masthead mt-2 text-2xl font-black text-stone-900 md:text-3xl">
            单事件完整时间线复盘
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-stone-500">
            以本周热度最高的「探店博主抄袭争议」为例，还原从发酵、反转到最新进展的每一个关键节点。
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center lg:flex-row lg:items-start lg:gap-8">
          {/* 时间线主区域 */}
          <div className="w-full flex-1">
            <div className="mb-6 flex flex-wrap items-center gap-3 rounded-lg border border-red-700/20 bg-red-50 px-4 py-3">
              <span className="inline-flex items-center gap-1 text-sm font-semibold text-red-800">
                <i className="ri-megaphone-fill"></i>
                本周追踪焦点
              </span>
              <h3 className="font-masthead flex-1 text-base font-bold text-stone-900">{title}</h3>
              <span className="rounded-full bg-white px-3 py-1 text-xs font-medium text-stone-500">
                共 {flagshipTimeline.length} 个节点 · 已核对
              </span>
            </div>

            <div className="relative">
              <div className="absolute bottom-2 left-[42px] top-2 w-px bg-orange-900/15 md:left-[54px]"></div>
              <div className="space-y-6">
                {flagshipTimeline.map((n) => {
                  const s = typeStyle[n.type];
                  return (
                    <div key={n.time} className="relative flex gap-4 md:gap-5">
                      <div className="w-[44px] shrink-0 text-right md:w-[56px]">
                        <p className="font-masthead text-sm font-bold text-stone-800">{n.date}</p>
                        <p className="text-[11px] text-stone-400">{n.time}</p>
                      </div>
                      <div className="relative flex flex-col items-center pt-1">
                        <span className={`relative z-10 h-3 w-3 rounded-full ${s.dot} ring-4 ring-white`}></span>
                      </div>
                      <div className="flex-1 rounded-lg border border-orange-900/10 bg-[#faf6ee] p-4 md:p-5">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${s.badge}`}>
                            {s.label}
                          </span>
                          <h4 className="text-sm font-semibold text-stone-900">{n.title}</h4>
                        </div>
                        <p className="mt-2 text-sm leading-relaxed text-stone-500">{n.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* 侧栏：追踪订阅说明 */}
          <aside className="mt-8 w-full max-w-xs lg:mt-0">
            <div className="rounded-xl border border-orange-900/10 bg-gradient-to-b from-red-700 to-red-800 p-5 text-white">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/15">
                <i className="ri-notification-4-line text-xl"></i>
              </div>
              <h3 className="font-masthead mt-3 text-lg font-bold">跟上进度，不再漏掉关键进展</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/85">
                订阅后，每当事件进入反转或当事人作出最新回应，我们都会第一时间推送更新提醒。
              </p>
              <a
                href="#subscribe"
                className="mt-4 flex items-center justify-center whitespace-nowrap rounded-md bg-white px-4 py-2.5 text-sm font-semibold text-red-800 transition-colors hover:bg-amber-100"
              >
                立即订阅追踪
              </a>
              <div className="mt-4 flex items-center gap-2 text-xs text-white/70">
                <i className="ri-shield-check-line"></i>
                实时追踪 · 信源可查
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}